import {
  AbstractApiClient,
  IApiClientOptions,
} from "../AbstractApiClient/AbstractApiClient";
import { UNSAFE__forceExpireCookies } from "./routes/UNSAFE__forceExpireCookies/UNSAFE__forceExpireCookies";
import { addCustomerAccountContact } from "./routes/addCustomerAccountContact/addCustomerAccountContact";
import { assertPartnerCanAccessCompany } from "./routes/assertPartnerCanAccessCompany/assertPartnerCanAccessCompany";
import { calculateCharges } from "./routes/calculateCharges/calculateCharges";
import { company } from "./routes/company/company";
import { createBankAccountAsWorker } from "./routes/createBankAccountAsWorker/createBankAccountAsWorker";
import { createCompanyLocation } from "./routes/createCompanyLocation/createCompanyLocation";
import { createContractor } from "./routes/createContractor/createContractor";
import { createContractorPayment } from "./routes/createContractorPayment/createContractorPayment";
import { createPaymentItem } from "./routes/createPaymentItem/createPaymentItem";
import { createCustomerAccount } from "./routes/createCustomerAccount/createCustomerAccount";
import { createEmployee } from "./routes/createEmployee/createEmployee";
import { createEmployeeCheck } from "./routes/createEmployeeCheck/createEmployeeCheck";
import { createLaborPoster } from "./routes/createLaborPoster/createLaborPoster";
import { createLaborPosterVersion } from "./routes/createLaborPosterVersion/createLaborPosterVersion";
import { createOrder } from "./routes/createOrder/createOrder";
import { updateOrder } from "./routes/updateOrder/updateOrder";
import { createPayrollRun } from "./routes/createPayrollRun/createPayrollRun";
import { deleteCheck } from "./routes/deleteCheck/deleteCheck";
import { deleteContractorPayment } from "./routes/deleteContractorPayment/deleteContractorPayment";
import { deletePaymentItem } from "./routes/deletePaymentItem/deletePaymentItem";
import { deleteMember } from "./routes/deleteMember/deleteMember";
import { deletePayrollRun } from "./routes/deletePayrollRun/deletePayrollRun";
import { deleteShift } from "./routes/deleteShift/deleteShift";
import { downloadCompanyTaxDocumentUrl } from "./routes/downloadCompanyTaxDocumentUrl/downloadCompanyTaxDocumentUrl";
import { downloadPoaDocument } from "./routes/downloadPoaDocument/downloadPoaDocument";
import { features } from "./routes/features/features";
import { finishHomeSetup } from "./routes/finishHomeSetup/finishHomeSetup";
import { generateDocumentGetUrl } from "./routes/generateDocumentGetUrl/generateDocumentGetUrl";
import { generateIdGetUrl } from "./routes/generateIdGetUrl/generateIdGetUrl";
import { generateLogoGetUrl } from "./routes/generateLogoGetUrl/generateLogoGetUrl";
import { generateLogoPutUrl } from "./routes/generateLogoPutUrl/generateLogoPutUrl";
import { getAdminInfo } from "./routes/getAdminInfo/getAdminInfo";
import { getAdminReviewFlags } from "./routes/getAdminReviewFlags/getAdminReviewFlags";
import { getCharge } from "./routes/getCharge/getCharge";
import { getChargesPolicies } from "./routes/getChargesPolicies/getChargesPolicies";
import { getCheckDates } from "./routes/getCheckDates/getCheckDates";
import { getCheckDatesReportingDetails } from "./routes/getCheckDatesReportingDetails/getCheckDatesReportingDetails";
import { getCheckPreview } from "./routes/getCheckPreview/getCheckPreview";
import { getChecksExistAlert } from "./routes/getChecksExistAlert/getChecksExistAlert";
import { getClosestCheckDate } from "./routes/getClosestCheckDate/getClosestCheckDate";
import { getCompanyDebits } from "./routes/getCompanyDebits/getCompanyDebits";
import { getCompanyLocations } from "./routes/getCompanyLocations/getCompanyLocations";
import { getDepartments } from "./routes/getDepartments/getDepartments";
import { postDepartments } from "./routes/postDepartments/postDepartments";
import { patchDepartments } from "./routes/patchDepartments/patchDepartments";
import { patchDepositRule } from "./routes/patchDepositRule/patchDepositRule";
import { patchAccrualBalance } from "./routes/patchAccrualBalance/patchAccrualBalance";
import { deleteDepartment } from "./routes/deleteDepartment/deleteDepartment";
import { deleteDepositRule } from "./routes/deleteDepositRule/deleteDepositRule";
import { getCompanyTaskDefinitions } from "./routes/getCompanyTaskDefinitions/getCompanyTaskDefinitions";
import { getCompanyTaxDocument } from "./routes/getCompanyTaxDocument/getCompanyTaxDocument";
import { getCompanyTaxDocuments } from "./routes/getCompanyTaxDocuments/getCompanyTaxDocuments";
import { getCompanyTaxRequirements } from "./routes/getCompanyTaxRequirements/getCompanyTaxRequirements";
import { getCompanyVeriffToken } from "./routes/getCompanyVeriffToken/getCompanyVeriffToken";
import { getContractorInfo } from "./routes/getContractorInfo/getContractorInfo";
import { getContractorInfoByPayload } from "./routes/getContractorInfoByPayload/getContractorInfoByPayload";
import { getContractorPayment } from "./routes/getContractorPayment/getContractorPayment";
import { getSingleContractorPaymentAsContractor } from "./routes/getSingleContractorPaymentAsContractor/getSingleContractorPaymentAsContractor";
import { getContractorPayments } from "./routes/getContractorPayments/getContractorPayments";
import { getContractorPaymentsAsContractor } from "./routes/getContractorPaymentsAsContractor/getContractorPaymentsAsContractor";
import { getContractors } from "./routes/getContractors/getContractors";
import { getDeductionTemplateSummary } from "./routes/getDeductionTemplateSummary/getDeductionTemplateSummary";
import { getDeductionTypeConfig } from "./routes/getDeductionTypeConfig/getDeductionTypeConfig";
import { getContractorDeductionTemplates } from "./routes/getContractorDeductionTemplates/getContractorDeductionTemplates";
import { createContractorDeductionTemplate } from "./routes/createContractorDeductionTemplate/createContractorDeductionTemplate";
import { archiveContractorDeductionTemplate } from "./routes/archiveContractorDeductionTemplate/archiveContractorDeductionTemplate";
import { postContractorPaymentDeduction } from "./routes/postContractorPaymentDeduction/postContractorPaymentDeduction";
import { deleteContractorPaymentDeduction } from "./routes/deleteContractorPaymentDeduction/deleteContractorPaymentDeduction";
import { patchContractorPaymentDeduction } from "./routes/patchContractorPaymentDeduction/patchContractorPaymentDeduction";
import { updateContractorDeductionTemplate } from "./routes/updateContractorDeductionTemplate/updateContractorDeductionTemplate";
import { getContractorsGrossPay } from "./routes/getContractorsGrossPay/getContractorsGrossPay";
import { getOrders } from "./routes/getOrders/getOrders";
import { getOrderStatistics } from "./routes/getOrderStatistics/getOrderStatistics";
import { getCurrentUser } from "./routes/getCurrentUser/getCurrentUser";
import { getCustomReportConfigs } from "./routes/getCustomReportConfigs/getCustomReportConfigs";
import { getDocuments } from "./routes/getDocuments/getDocuments";
import { getEmployeeCheck } from "./routes/getEmployeeCheck/getEmployeeCheck";
import { getEmployeeCheckDetails } from "./routes/getEmployeeCheckDetails/getEmployeeCheckDetails";
import { getEmployeeCheckInfo } from "./routes/getEmployeeCheckInfo/getEmployeeCheckInfo";
import { getEmployeeChecks } from "./routes/getEmployeeChecks/getEmployeeChecks";
import { getEmployeeChecksByPayload } from "./routes/getEmployeeChecksByPayload/getEmployeeChecksByPayload";
import { getEmployeeReportingPeriods } from "./routes/getEmployeeReportingPeriods/getEmployeeReportingPeriods";
import { getFaxes } from "./routes/getFaxes/getFaxes";
import { getGovernmentIdUrls } from "./routes/getGovernmentIdUrls/getGovernmentIdUrls";
import { getNewHireReportingSummary } from "./routes/getNewHireReportingSummary/getNewHireReportingSummary";
import { getNewHireWorkers } from "./routes/getNewHireWorkers/getNewHireWorkers";
import { patchNewHireWorkerStatus } from "./routes/patchNewHireWorkerStatus/patchNewHireWorkerStatus";
import { generateNewHireFileUrl } from "./routes/generateNewHireFileUrl/generateNewHireFileUrl";
import { getGuestInfo } from "./routes/getGuestInfo/getGuestInfo";
import { getInternalUserInfo } from "./routes/getInternalUserInfo/getInternalUserInfo";
import { getMembers } from "./routes/getMembers/getMembers";
import { getMyContractorPayments } from "./routes/getMyContractorPayments/getMyContractorPayments";
import { getMyEmployerChecks } from "./routes/getMyEmployerChecks/getMyEmployerChecks";
import { getMyRecentlyOnboardedContractors } from "./routes/getMyRecentlyOnboardedContractors/getMyRecentlyOnboardedContractors";
import { getMyRecentlyOnboardedWorkers } from "./routes/getMyRecentlyOnboardedWorkers/getMyRecentlyOnboardedWorkers";
import { getMyWorkers } from "./routes/getMyWorkers/getMyWorkers";
import { getOnboardingAuthLink } from "./routes/getOnboardingAuthLink/getOnboardingAuthLink";
import { getOnboardingLink } from "./routes/getOnboardingLink/getOnboardingLink";
import { getPartnerInfo } from "./routes/getPartnerInfo/getPartnerInfo";
import { getPaycardEnrollmentActionRequired } from "./routes/getPaycardEnrollmentActionRequired/getPaycardEnrollmentActionRequired";
import { getPayrollChecks } from "./routes/getPayrollChecks/getPayrollChecks";
import { getPayrollRuns } from "./routes/getPayrollRuns/getPayrollRuns";
import { getPendingChecks } from "./routes/getPendingChecks/getPendingChecks";
import { getPendingShifts } from "./routes/getPendingShifts/getPendingShifts";
import { getPoaDocuments } from "./routes/getPoaDocuments/getPoaDocuments";
import { getPartnerSecurityDocumentUrl } from "./routes/getPartnerSecurityDocumentUrl/getPartnerSecurityDocumentUrl";
import { listPartnerSecurityDocuments } from "./routes/listPartnerSecurityDocuments/listPartnerSecurityDocuments";
import { getReportingPeriodsByFrequency } from "./routes/getReportingPeriodsByFrequency/getReportingPeriodsByFrequency";
import { getReportsStatus } from "./routes/getReportsStatus/getReportsStatus";
import { getSecondaryJWT } from "./routes/getSecondaryJWT/getSecondaryJWT";
import { getSubEmployeeChecks } from "./routes/getSubEmployeeChecks/getSubEmployeeChecks";
import { getUpcomingChecks } from "./routes/getUpcomingChecks/getUpcomingChecks";
import { getUserInfo } from "./routes/getUserInfo/getUserInfo";
import { getWLAlerts } from "./routes/getWLAlerts/getWLAlerts";
import { getWLHostedConfig } from "./routes/getWLHostedConfig/getWLHostedConfig";
import { getWLInfo } from "./routes/getWLInfo/getWLInfo";
import { getWLInfoById } from "./routes/getWLInfoById/getWLInfoById";
import { getWorkerIds } from "./routes/getWorkerIds/getWorkerIds";
import { getWorkerInfo } from "./routes/getWorkerInfo/getWorkerInfo";
import { getWorkerInfoByPayload } from "./routes/getWorkerInfoByPayload/getWorkerInfoByPayload";
import { getWorkerTasks } from "./routes/getWorkerTasks/getWorkerTasks";
import { getWorkerTasksStatus } from "./routes/getWorkerTasksStatus/getWorkerTasksStatus";
import { inviteMember } from "./routes/inviteMember/inviteMember";
import { login } from "./routes/login/login";
import { logout } from "./routes/logout/logout";
import { postCashRequirements } from "./routes/postCashRequirements/postCashRequirements";
import { postCustomPayrollJournal } from "./routes/postCustomPayrollJournal/postCustomPayrollJournal";
import { postGenerateContractorIDUploadLinkPrivate } from "./routes/postGenerateContractorIDUploadLinkPrivate/postGenerateContractorIDUploadLinkPrivate";
import { postGenerateEmployeeIDUploadLinkPrivate } from "./routes/postGenerateEmployeeIDUploadLinkPrivate/postGenerateEmployeeIDUploadLinkPrivate";
import { postGeneratePaystubFile } from "./routes/postGeneratePaystubFile/postGeneratePaystubFile";
import { postLaborAllocation } from "./routes/postLaborAllocation/postLaborAllocation";
import { postPaymentSummary } from "./routes/postPaymentSummary/postPaymentSummary";
import { postPayrollJournal } from "./routes/postPayrollJournal/postPayrollJournal";
import { postPaystub } from "./routes/postPaystub/postPaystub";
import { postPreviewCheckData } from "./routes/postPreviewCheckData/postPreviewCheckData";
import { postWorkerSummary } from "./routes/postWorkerSummary/postWorkerSummary";
import { resendFax } from "./routes/resendFax/resendFax";
import { rollKey } from "./routes/rollKey/rollKey";
import { sendContractorOnboardingLink } from "./routes/sendContractorOnboardingLink/sendContractorOnboardingLink";
import { sendOnboardingLink } from "./routes/sendOnboardingLink/sendOnboardingLink";
import { setFaviconStatus } from "./routes/setFaviconStatus/setFaviconStatus";
import { setLogoStatus } from "./routes/setLogoStatus/setLogoStatus";
import { setUserPayrollRunSettings } from "./routes/setUserPayrollRunSettings/setUserPayrollRunSettings";
import { submitPayrollRun } from "./routes/submitPayrollRun/submitPayroll";
import { submitOrder } from "./routes/submitOrder/submitOrder";
import { toggleOrderStatus } from "./routes/toggleOrderStatus/toggleOrderStatus";
import { submitPersonaVerification } from "./routes/submitPersonaVerification/submitPersonaVerification";
import { submitShift } from "./routes/submitShift/submitShift";
import { testCheckCreatedWebhook } from "./routes/testCheckCreatedWebhook/testCheckCreatedWebhook";
import { testCheckProcessedLeanWebhook } from "./routes/testCheckProcessedLeanWebhook/testCheckProcessedLeanWebhook";
import { testCheckProcessedWebhook } from "./routes/testCheckProcessedWebhook/testCheckProcessedWebhook";
import { testContractorPaymentWebhook } from "./routes/testContractorPaymentWebhook/testContractorPaymentWebhook";
import { testContractorWebhook } from "./routes/testContractorWebhook/testContractorWebhook";
import { testCreationWebhook } from "./routes/testCreationWebhook/testCreationWebhook";
import { testEmployeeCheckWebhook } from "./routes/testEmployeeCheckWebhook/testEmployeeCheckWebhook";
import { testEmployeeWebhook } from "./routes/testEmployeeWebhook/testEmployeeWebhook";
import { testEmployerOnboardingWebhook } from "./routes/testEmployerOnboardingWebhook/testEmployerOnboardingWebhook";
import { testOnboardingWebhook } from "./routes/testOnboardingWebhook/testOnboardingWebhook";
import { testReportWebhook } from "./routes/testReportWebhook/testReportWebhook";
import { testShiftWebhook } from "./routes/testShiftWebhook/testShiftWebhook";
import { token } from "./routes/token/token";
import { updateAdminInfo } from "./routes/updateAdminInfo/updateAdminInfo";
import { updateCheck } from "./routes/updateCheck/updateCheck";
import { updateCheckCreatedWebhook } from "./routes/updateCheckCreatedWebhook/updateCheckCreatedWebhook";
import { updateCheckProcessedLeanWebhook } from "./routes/updateCheckProcessedLeanWebhook/updateCheckProcessedLeanWebhook";
import { updateCheckProcessedWebhook } from "./routes/updateCheckProcessedWebhook/updateCheckProcessedWebhook";
import { updateCompanyLocation } from "./routes/updateCompanyLocation/updateCompanyLocation";
import { updateCompanyTaxDocumentById } from "./routes/updateCompanyTaxDocumentById/updateCompanyTaxDocumentById";
import { updateCompanyVeriffToken } from "./routes/updateCompanyVeriffToken/updateCompanyVeriffToken";
import { updateContractor } from "./routes/updateContractor/updateContractor";
import { updateContractorPaymentWebhook } from "./routes/updateContractorPaymentWebhook/updateContractorPaymentWebhook";
import { updateContractorWebhook } from "./routes/updateContractorWebhook/updateContractorWebhook";
import { updateCreationWebhook } from "./routes/updateCreationWebhook/updateCreationWebhook";
import { updateEmployeeAsCompany } from "./routes/updateEmployeeAsCompany/updateEmployeeAsCompany";
import { updateCompanyTaxParameter } from "./routes/updateCompanyTaxParameter/updateCompanyTaxParameter";
import { updateEmployeeCheckByID } from "./routes/updateEmployeeCheckByID/updateEmployeeCheckByID";
import { updateEmployeeCheckWebhook } from "./routes/updateEmployeeCheckWebhook/updateEmployeeCheckWebhook";
import { updateEmployeeWebhook } from "./routes/updateEmployeeWebhook/updateEmployeeWebhook";
import { updateEmployerOnboardingWebhook } from "./routes/updateEmployerOnboardingWebhook/updateEmployerOnboardingWebhook";
import { updateGuestInfo } from "./routes/updateGuestInfo/updateGuestInfo";
import { updateLaborPoster } from "./routes/updateLaborPoster/updateLaborPoster";
import { updateOnboardingWebhook } from "./routes/updateOnboardingWebhook/updateOnboardingWebhook";
import { updatePayrollRun } from "./routes/updatePayrollRun/updatePayrollRun";
import { updateReportWebhook } from "./routes/updateReportWebhook/updateReportWebhook";
import { updateShift } from "./routes/updateShift/updateShift";
import { updateShiftWebhook } from "./routes/updateShiftWebhook/updateShiftWebhook";
import { uploadTaxParameters } from "./routes/updateTaxParameters/updateTaxParameters";
import { updateUserInfo } from "./routes/updateUserInfo/updateUserInfo";
import { updateWLInfo } from "./routes/updateWLInfo/updateWLInfo";
import { uploadIDVerification } from "./routes/uploadIDVerification/uploadIDVerification";
import { updateImageAws } from "./routes/uploadImageAws/uploadImageAws";
import { getCompanyDocumentPdf } from "./routes/getCompanyDocumentPdf/getCompanyDocumentPdf";
import { createVeriffSession } from "./routes/veriff/createVeriffSession";
import { whoami } from "./routes/whoami/whoami";
import {
  LaForgeSchemaAssertionWithParams,
  assertValidLaForgeSchema,
} from "./validation-types/assertValidLaForgeSchema";

import {
  addFilterRule,
  addGroupRule,
  createAttribute,
  createOrUpdateApplyAttribute,
  createRuleSet,
  deleteAttribute,
  deleteRuleSet,
  evaluateRuleSet,
  getCurrentState,
  getRuleSet,
  listRuleSets,
  moveRule,
  queryAttributes,
  queryWorkerAttributes,
  readAttribute,
  removeRule,
  updateAttribute,
  updateFilterRule,
  updateGroupOperator,
} from "./routes/CustomAttributes";
import {
  archivePaperworkTemplate,
  getPaperworkTemplate,
  patchPaperworkTemplate,
  postPaperworkTemplate,
  putPaperworkTemplate,
} from "./routes/CustomPaperwork";
import { acknowledgeHealthInsurance } from "./routes/acknowledgeHealthInsurance/acknowledgeHealthInsurance";
import { approveCheck } from "./routes/approveCheck/approveCheck";
import { checkCookie } from "./routes/checkCookie/checkCookie";
import { completeEmployerOnboardingFlow } from "./routes/completeEmployerOnboardingFlow/completeEmployerOnboardingFlow";
import { createAccount } from "./routes/createAccount/createAccount";
import { createAppleWalletProvision } from "./routes/createAppleWalletProvision/createAppleWalletProvision";
import { createBankAccount } from "./routes/createBankAccount/createBankAccount";
import { createBankAccountAndSignForms } from "./routes/createBankAccountAndSignForms/createBankAccountAndSignForms";
import { createCompanyBankAccount } from "./routes/createCompanyBankAccount/createCompanyBankAccount";
import { createCompanyMicroDeposits } from "./routes/createCompanyMicroDeposits/createCompanyMicroDeposits";
import { createCompanyTaxDocument } from "./routes/createCompanyTaxDocument/createCompanyTaxDocument";
import { createCompanyTransaction } from "./routes/createCompanyTransaction/createCompanyTransaction";
import { createContractorPayCard } from "./routes/createContractorPayCard/createContractorPayCard";
import { createCustomPaperwork } from "./routes/createCustomPaperwork/createCustomPaperwork";
import { createEmployeeChecksFromBullhornCsv } from "./routes/createEmployeeChecksFromBullhornCsv/createEmployeeChecksFromBullhornCsv";
import { createEmployeePayCard } from "./routes/createEmployeePayCard/createEmployeePayCard";
import { createFinixCard } from "./routes/createFinixCard/createFinixCard";
import { createFundingSource } from "./routes/createFundingSource/createFundingSource";
import { createGoogleWalletProvision } from "./routes/createGoogleWalletProvision/createGoogleWalletProvision";
import { createPayment } from "./routes/createPayment/createPayment";
import { createPayrollRunChecks } from "./routes/createPayrollRunChecks/createPayrollRunChecks";
import { createWalletTransaction } from "./routes/createWalletTransaction/createWalletTransaction";
import { createWorkerAstraUser } from "./routes/createWorkerAstraUser/createWorkerAstraUser";
import { createWorkerWallet } from "./routes/createWorkerWallet/createWorkerWallet";
import { deletePushToCardUserCard } from "./routes/deletePushToCardUserCard/deletePushToCardUserCard";
import { downloadEVerifyNotice } from "./routes/downloadEVerifyNotice/downloadEVerifyNotice";
import { downloadGarnishmentDocument } from "./routes/downloadGarnishmentDocument/downloadGarnishmentDocument";
import { downloadLaborPoster } from "./routes/downloadLaborPoster/downloadLaborPoster";
import { downloadLaborPosterTemplate } from "./routes/downloadLaborPosterTemplate/downloadLaborPosterTemplate";
import { enableWorkerInstantPay } from "./routes/enableWorkerInstantPay/enableWorkerInstantPay";
import { fetchCheckDetails } from "./routes/fetchCheckDetails/fetchCheckDetails";
import { fetchCustomPaperwork } from "./routes/fetchCustomPaperwork/fetchCustomPaperwork";
import { generateCustomerAccountOnboardingLink } from "./routes/generateCustomerAccountOnboardingLink/generateCustomerAccountOnboardingLink";
import { generateFileGetUrl } from "./routes/generateFileGetUrl/generateFileGetUrl";
import { generateFilePutUrl } from "./routes/generateFilePutUrl/generateFilePutUrl";
import { generateFilesPutUrl } from "./routes/generateFilesPutUrl/generateFilesPutUrl";
import { getAccrualBalances } from "./routes/getAccrualBalances/getAccrualBalances";
import { getAccrualBalancesByEmployee } from "./routes/getAccrualBalancesByEmployee/getAccrualBalancesByEmployee";
import { getAccrualPolicies } from "./routes/getAccrualPolicies/getAccrualPolicies";
import { getAccrualPoliciesActivity } from "./routes/getAccrualPoliciesActivity/getAccrualPoliciesActivity";
import { getAccrualPoliciesWorkers } from "./routes/getAccrualPoliciesWorkers/getAccrualPoliciesWorkers";
import { getEWAPolicies } from "./routes/getEWAPolicies/getEWAPolicies";
import { getAccrualPolicy } from "./routes/getAccrualPolicy/getAccrualPolicy";
import { getAccrualPolicyCodes } from "./routes/getAccrualPolicyCodes/getAccrualPolicyCodes";
import { getAccrualPreviews } from "./routes/getAccrualPreviews/getAccrualPreviews";
import { getActivePayrollRuns } from "./routes/getActivePayrollRuns/getActivePayrollRuns";
import { getBankAccount } from "./routes/getBankAccount/getBankAccount";
import { getBulkEVerifyPublicCaseStatuses } from "./routes/getBulkEVerifyPublicCaseStatuses/getBulkEVerifyPublicCaseStatuses";
import { getCheckCsvTemplate } from "./routes/getCheckCsvTemplate/getCheckCsvTemplate";
import { getCheckPDF } from "./routes/getCheckPDF/getCheckPDF";
import { getCompaniesUnsignedAgreementsStatus } from "./routes/getCompaniesUnsignedAgreementsStatus/getCompaniesUnsignedAgreementsStatus";
import { getCompanyAccounts } from "./routes/getCompanyAccounts/getCompanyAccounts";
import { getCompanyKybDocuments } from "./routes/getCompanyKybDocuments/getCompanyKybDocuments";
import { getCompanyMFATypes } from "./routes/getCompanyMFATypes/getCompanyMFATypes";
import { getContractorPayCards } from "./routes/getContractorPayCards/getContractorPayCards";
import { getContractorPaycardDisclosures } from "./routes/getContractorPaycardDisclosures/getContractorPaycardDisclosures";
import { getContractorPaycardStatement } from "./routes/getContractorPaycardStatement/getContractorPaycardStatement";
import { getContractorPaycardStatements } from "./routes/getContractorPaycardStatements/getContractorPaycardStatements";
import { getContractorPaymentGroupById } from "./routes/getContractorPaymentGroupById/getContractorPaymentGroupById";
import { getContractorPaymentGroups } from "./routes/getContractorPaymentGroups/getContractorPaymentGroups";
import { getCurrentUserAccounts } from "./routes/getCurrentUserAccounts/getCurrentUserAccounts";
import { getCustomPaperworkTemplates } from "./routes/getCustomPaperworkTemplates/getCustomPaperworkTemplates";
import { getCustomerAccountOnboardingInfo } from "./routes/getCustomerAccountOnboardingInfo/getCustomerAccountOnboardingInfo";
import { getCustomerAccounts } from "./routes/getCustomerAccounts/getCustomerAccounts";
import { getDirectPayments } from "./routes/getDirectPayments/getDirectPayments";
import { getDoesUserExist } from "./routes/getDoesUserExist/getDoesUserExist";
import { getEmbeddingSignedToken } from "./routes/getEmbeddingSignedToken/getEmbeddingSignedToken";
import { getEmployeeCheckDeductions } from "./routes/getEmployeeCheckDeductions/getEmployeeCheckDeductions";
import { getEmployeeCheckDisbursementEvents } from "./routes/getEmployeeCheckDisbursementEvents/getEmployeeCheckDisbursementEvents";
import { getEmployeePayCards } from "./routes/getEmployeePayCards/getEmployeePayCards";
import { getEmployeePaycardDisclosures } from "./routes/getEmployeePaycardDisclosures/getEmployeePaycardDisclosures";
import { getEmployeePaycardStatement } from "./routes/getEmployeePaycardStatement/getEmployeePaycardStatement";
import { getEmployeePaycardStatements } from "./routes/getEmployeePaycardStatements/getEmployeePaycardStatements";
import { getEmployeeRequirementsLinks } from "./routes/getEmployeeRequirementLinks/getEmployeeRequirementsLinks";
import { getEmployerCheckById } from "./routes/getEmployerCheckById/getEmployerCheckById";
import { getEmployerCheckDisbursementEvents } from "./routes/getEmployerCheckDisbursementEvents/getEmployerCheckDisbursementEvents";
import { getEmployerCheckInternal } from "./routes/getEmployerCheckInternal/getEmployerCheckInternal";
import { getFinixCards } from "./routes/getFinixCards/getFinixCards";
import { getFinixInfo } from "./routes/getFinixInfo/getFinixInfo";
import { getFormList } from "./routes/getFormList/getFormList";
import { getFormSubmissions } from "./routes/getFormSubmissions/getFormSubmissions";
import { getFormTemplate } from "./routes/getFormTemplate/getFormTemplate";
import { getFrigadeClient } from "./routes/getFrigadeClient/getFrigadeClient";
import { getFurtherActionNoticeURLsByWorkerIDs } from "./routes/getFurtherActionNoticeURLsByWorkerIDs/getFurtherActionNoticeURLsByWorkerIDs";
import { getI9OnboardingInfo } from "./routes/getI9OnboardingInfo/getI9OnboardingInfo";
import { getI9OnboardingLink } from "./routes/getI9OnboardingLink/getI9OnboardingLink";
import { getWorkerI9Data } from "./routes/getWorkerI9Data/getWorkerI9Data";
import { getWorkerI9MetricsAndStats } from "./routes/getWorkerI9MetricsAndStats/getWorkerI9MetricsAndStats";
import { getEmployeeI9Documents } from "./routes/getEmployeeI9Documents/getEmployeeI9Documents";
import { postManualUploadI9Document } from "./routes/postManualUploadI9Document/postManualUploadI9Document";
import { postUploadI9Document } from "./routes/postUploadI9Document/postUploadI9Document";
import { getI9ReviewProgress } from "./routes/getI9ReviewProgress/getI9ReviewProgress";
import { getInfoForAuthorizedRepresentative } from "./routes/getInfoForAuthorizedRepresentative/getInfoForAuthorizedRepresentative";
import { getInternationalForm } from "./routes/getInternationalForm/getInternationalForm";
import { getJobs } from "./routes/getJobs/getJobs";
import { getJurisdictionLaborPosters } from "./routes/getJurisdictionLaborPosters/getJurisdictionLaborPosters";
import { getKYC } from "./routes/getKYC/getKYC";
import { getLaborPoster } from "./routes/getLaborPoster/getLaborPoster";
import { getLaborPosters } from "./routes/getLaborPosters/getLaborPosters";
import { getLocalTaxTypes } from "./routes/getLocalTaxTypes/getLocalTaxTypes";
import { getNextRegularPayrollRun } from "./routes/getNextRegularPayrollRun/getNextRegularPayrollRun";
import { getNextRegularRun } from "./routes/getNextRegularRun/getNextRegularRun";
import { getOnboardingInfo } from "./routes/getOnboardingInfo/getOnboardingInfo";
import { getPayCard } from "./routes/getPayCard/getPayCard";
import { getPayCardArt } from "./routes/getPayCardArt/getPayCardArt";
import { getPayCardToken } from "./routes/getPayCardToken/getPayCardToken";
import { getPayCardTransactions } from "./routes/getPayCardTransactions/getPayCardTransactions";
import { getPaycardTransaction } from "./routes/getPaycardTransaction/getPaycardTransaction";
import { getPayrollRun } from "./routes/getPayrollRun/getPayrollRun";
import { getPayrollRunById } from "./routes/getPayrollRunById/getPayrollRunById";
import { getPayrollRunEmployees } from "./routes/getPayrollRunEmployees/getPayrollRunEmployees";
import { getPendingEVerifyActionByAdmin } from "./routes/getPendingEVerifyActionByAdmin/getPendingEVerifyActionByAdmin";
import { getPermissions } from "./routes/getPermissions/getPermissions";
import { getPersonaDecision } from "./routes/getPersonaDecision/getPersonaDecision";
import { getPreviewChecks } from "./routes/getPreviewChecks/getPreviewChecks";
import { getQuickviewContractorInfo } from "./routes/getQuickviewContractorInfo/getQuickviewContractorInfo";
import { getQuickviewWorkerInfo } from "./routes/getQuickviewWorkerInfo/getQuickviewWorkerInfo";
import { getStateTaxConfig } from "./routes/getStateTaxConfig/getStateTaxConfig";
import { getTaxSetupInfo } from "./routes/getTaxSetupInfo/getTaxSetupInfo";
import { getTransactionByConnectionID } from "./routes/getTransactionByConnectionID/getTransactionByConnectionID";
import { getTransactionEvents } from "./routes/getTransactionEvents/getTransactionEvents";
import { getTransactions } from "./routes/getTransactions/getTransactions";
import { getVeriffDecision } from "./routes/getVeriffDecision/getVeriffDecision";
import { getVeriffIds } from "./routes/getVeriffIds/getVeriffIds";
import { getWageViolations } from "./routes/getWageViolations/getWageViolations";
import { getWalletStatistics } from "./routes/getWalletStatistics/getWalletStatistics";
import { getWalletTransactions } from "./routes/getWalletTransactions/getWalletTransactions";
import { getWallets } from "./routes/getWallets/getWallets";
import { getWorker } from "./routes/getWorker/getWorker";
import { getWorkerAstraCard } from "./routes/getWorkerAstraCard/getWorkerAstraCard";
import { getWorkerAstraUser } from "./routes/getWorkerAstraUser/getWorkerAstraUser";
import { getHeadcount } from "./routes/getHeadcount/getHeadcount";
import { getWorkerCount } from "./routes/getWorkerCount/getWorkerCount";
import { getWorkerWalletTransactions } from "./routes/getWorkerWalletTransactions/getWorkerWalletTransactions";
import { getWorkerWallets } from "./routes/getWorkerWallets/getWorkerWallets";
import { onboardCustomerAccount } from "./routes/onboardCustomerAccount/onboardCustomerAccount";
import { patchTaxSetupInfo } from "./routes/patchTaxSetupInfo/patchTaxSetupInfo";
import { migrateEmployeeData } from "./routes/payrollMigration/migrateEmployeeData";
import { migrateContractorData } from "./routes/payrollMigration/migrateContractorData";
import { migrateEmployeeTaxParamsData } from "./routes/payrollMigration/migrateEmployeeTaxParamsData";
import { migrateContractorPayment } from "./routes/payrollMigration/migrateContractorPayment";
import { postAttachEVerifyDocumentToWorker } from "./routes/postAttachEVerifyDocumentToWorker/postAttachEVerifyDocumentToWorker";
import { postArchiveWorkerBankAccount } from "./routes/postArchiveWorkerBankAccount/postArchiveWorkerBankAccount";
import { postCompanyDebits } from "./routes/postCompanyDebits/postCompanyDebits";
import { postCreatePayrollRun } from "./routes/postCreatePayrollRun/postCreatePayrollRun";
import { postCustomReport } from "./routes/postCustomReport/postCustomReport";
import { postDeductionsSummary } from "./routes/postDeductionsSummary/postDeductionsSummary";
import { postEmployees } from "./routes/postEmployees/postEmployees";
import { postForm } from "./routes/postForm/postForm";
import { postFormRenderJSON } from "./routes/postFormRenderJSON/postFormRenderJSON";
import { postFormRenderPDF } from "./routes/postFormRenderPDF/postFormRenderPDF";
import { postGarnishmentDocument } from "./routes/postGarnishmentDocument/postGarnishmentDocument";
import { getCanadianPayrollBusinessEntity } from "./routes/getCanadianPayrollBusinessEntity/getCanadianPayrollBusinessEntity";
import { patchCanadianPayrollBusinessEntity } from "./routes/patchCanadianPayrollBusinessEntity/patchCanadianPayrollBusinessEntity";
import { postGenerateCanadianPayrollOnboardingLink } from "./routes/postGenerateCanadianPayrollOnboardingLink/postGenerateCanadianPayrollOnboardingLink";
import { postUpdateCanadianPayrollBusinessEntity } from "./routes/postUpdateCanadianPayrollBusinessEntity/postUpdateCanadianPayrollBusinessEntity";
import { postGenerateCompanyShareableLink } from "./routes/postGenerateCompanyShareableLink/postGenerateCompanyShareableLink";
import { postGenerateShareableLink } from "./routes/postGenerateShareableLink/postGenerateShareableLink";
import { postGenerateSSEToken } from "./routes/postGenerateSSEToken/postGenerateSSEToken";
import { postGenerateW4UpdateLink } from "./routes/postGenerateW4UpdateLink/postGenerateW4UpdateLink";
import { postTriggerBulkPreviewChecks } from "./routes/postTriggerBulkPreviewChecks/postTriggerBulkPreviewChecks";
import { postI9EVerifySummary } from "./routes/postI9EVerifySummary/postI9EVerifySummary";
import { postKickBackWorkerI9 } from "./routes/postKickBackWorkerI9/postKickBackWorkerI9";
import { postRetryTransaction } from "./routes/postRetryTransaction/postRetryTransaction";
import { postSendPushNotifications } from "./routes/postSendPushNotifications/postSendPushNotifications";
import { postKycSummary } from "./routes/postKycSummary/postKycSummary";
import { postLaborAllocationXero } from "./routes/postLaborAllocationXero/postLaborAllocationXero";
import { postManageBulkDeductions } from "./routes/postManageBulkDeductions/postBulkManageDeductions";
import { postParseChecksCSV } from "./routes/postParseChecksCSV/postParseChecksCSV";
import { postParsePaymentsCsv } from "./routes/postParsePaymentsCsv/postParsePaymentsCsv";
import { postPushNotificationToken } from "./routes/postPushNotificationToken/postPushNotificationToken";
import { postResolveEVerifyFinalNonConfirmation } from "./routes/postResolveEVerifyFinalNonconfirmation/postResolveEVerifyFinalNonconfirmation";
import { postResolveEVerifyPendingReferral } from "./routes/postResolveEVerifyPendingReferral/postResolveEVerifyPendingReferral";
import { postSignNmbrRequest } from "./routes/postSignNmbrRequest/postSignNmbrRequest";
import { postTelemetry } from "./routes/postTelemetry/postTelemetry";
import { verifyMicroDeposits } from "./routes/postVerifyMicroDeposits/postVerifyMicroDeposits";
import { removeAccountMembership } from "./routes/removeAccountMembership/removeAccountMembership";
import { replaceI9AuthRepLocation } from "./routes/replaceI9Location/replaceI9AuthRepLocation";
import { replaceI9WorkerLocation } from "./routes/replaceI9Location/replaceI9WorkerLocation";
import { requestContractorPaycards } from "./routes/requestContractorPaycards/requestContractorPaycards";
import { requestEmployeePaycards } from "./routes/requestEmployeePaycards/requestEmployeePaycards";
import { saveCompanySignature } from "./routes/saveCompanySignature/saveCompanySignature";
import { saveEmployerOnboardingTerms } from "./routes/saveEmployerOnboardingTerms/saveEmployerOnboardingTerms";
import { saveStateTaxParams } from "./routes/saveStateTaxParams/saveStateTaxParams";
import { savePartnerSignature } from "./routes/savePartnerSignature/savePartnerSignature";
import { selectAccount } from "./routes/selectAccount/selectAccount";
import { sendI9OnboardingLink } from "./routes/sendI9OnboardingLink/sendI9OnboardingLink";
import { signCompanyAgreements } from "./routes/signCompanyAgreements/signCompanyAgreements";
import { submitEmailConfirmation } from "./routes/submitEmailConfirmation/submitEmailConfirmation";
import { submitInvoicePayment } from "./routes/submitInvoicePayment/submitInvoicePayment";
import { sendInvoiceEmail } from "./routes/sendInvoiceEmail/sendInvoiceEmail";
import { submitOrderPayment } from "./routes/submitOrderPayment/submitOrderPayment";
import { submitWorkerAccountInfo } from "./routes/submitWorkerAccountInfo/submitWorkerAccountInfo";
import { switchCheckToPending } from "./routes/switchCheckToPending/switchCheckToPending";
import { testCustomerAccountOnboardingWebhook } from "./routes/testCustomerAccountOnboardingWebhook/testCustomerAccountOnboardingWebhook";
import { testCustomerAccountUpdatedWebhook } from "./routes/testCustomerAccountUpdatedWebhook/testCustomerAccountUpdatedWebhook";
import { testEVerifyWebhook } from "./routes/testEVerifyWebhook/testEVerifyWebhook";
import { testEmployeeRequirementCreatedWebhook } from "./routes/testEmployeeRequirementCreatedWebhook/testEmployeeRequirementCreatedWebhook";
import { testEmployeeRequirementUpdatedWebhook } from "./routes/testEmployeeRequirementUpdatedWebhook/testEmployeeRequirementUpdatedWebhook";
import { testEmployerUpdatedWebhook } from "./routes/testEmployerUpdatedWebhook/testEmployerUpdatedWebhook";
import { testI9Webhook } from "./routes/testI9Webhook/testI9Webhook";
import { testWebhook } from "./routes/testWebhook/testWebhook";
import { testWorkerPaycardOnboardingWebhook } from "./routes/testWorkerPaycardOnboardingWebhook/testWorkerPaycardOnboardingWebhook";
import { transferPaycardFunds } from "./routes/transferPaycardFunds/transferPaycardFunds";
import { triggerContractorPayment } from "./routes/triggerContractorPayment/triggerContractorPayment";
import { updateAccrualPolicyWorkers } from "./routes/updateAccrualPolicyWorkers/updateAccrualPolicyWorkers";
import { updateBankAccount } from "./routes/updateBankAccount/updateBankAccount";
import { updateBankAccountAsWorker } from "./routes/updateBankAccountAsWorker/updateBankAccount";
import { updateCompany } from "./routes/updateCompany/updateCompany";
import { updateCompanyTaskDefinitions } from "./routes/updateCompanyTaskDefinitions/updateCompanyTaskDefinitions";
import { updateContractorPayment } from "./routes/updateContractorPayment/updateContractorPayment";
import { updatePaymentItem } from "./routes/updatePaymentItem/updatePaymentItem";
import { updateCustomPaperwork } from "./routes/updateCustomPaperwork/updateCustomPaperwork";
import { updateCustomerAccount } from "./routes/updateCustomerAccount/updateCustomerAccount";
import { updateCustomerAccountInfo } from "./routes/updateCustomerAccountInfo/updateCustomerAccountInfo";
import { updateCustomerAccountOnboardingWebhook } from "./routes/updateCustomerAccountOnboardingWebhook/updateCustomerAccountOnboardingWebhook";
import { updateCustomerAccountUpdatedWebhook } from "./routes/updateCustomerAccountUpdatedWebhook/updateCustomerAccountUpdatedWebhook";
import { updateEVerifyPublicCaseStatus } from "./routes/updateEVerifyPublicCaseStatus/updateEVerifyPublicCaseStatus";
import { updateEVerifyWebhook } from "./routes/updateEVerifyWebhook/updateEVerifyWebhook";
import { updateEmployee } from "./routes/updateEmployee/updateEmployee";
import { updateEmployeeAsSelf } from "./routes/updateEmployeeAsSelf/updateEmployeeAsSelf";
import { updateEmployeeRequirementCreatedWebhook } from "./routes/updateEmployeeRequirementCreatedWebhook/updateEmployeeRequirementCreatedWebhook";
import { updateEmployeeRequirementUpdatedWebhook } from "./routes/updateEmployeeRequirementUpdatedWebhook/updateEmployeeRequirementUpdatedWebhook";
import { updateEmployerUpdatedWebhook } from "./routes/updateEmployerUpdatedWebhook/updateEmployerUpdatedWebhook";
import { updateI9AdminReview } from "./routes/updateI9AdminReview/updateI9AdminReview";
import { updateI9OnboardingInfo } from "./routes/updateI9OnboardingInfo/updateI9OnboardingInfo";
import { updateI9OnboardingInfoAsAuthorizedRepresentative } from "./routes/updateI9OnboardingInfoAsAuthorizedRepresentative/updateI9OnboardingInfoAsAuthorizedRepresentative";
import { updateI9Webhook } from "./routes/updateI9Webhook/updateI9Webhook";
import { updatePartner } from "./routes/updatePartner/updatePartner";
import { updatePartnerQuestionnaire } from "./routes/updatePartnerQuestionnaire/updatePartnerQuestionnaire";
import { updatePaycard } from "./routes/updatePaycard/updatePaycard";
import { updateUserCard } from "./routes/updateUserCard/updateUserCard";
import { updateWebhook } from "./routes/updateWebhook/updateWebhook";
import { updateWorkerAstraUser } from "./routes/updateWorkerAstraUser/updateWorkerAstraUser";
import { updateWorkerMfaMethod } from "./routes/updateWorkerMfaMethod/updateWorkerMfaMethod";
import { updateWorkerPaycardOnboardingWebhook } from "./routes/updateWorkerPaycardOnboardingWebhook/updateWorkerPaycardOnboardingWebhook";
import { updateFileAws } from "./routes/uploadFileAws/uploadFileAws";
import { uploadI9OnboardingIDDocument } from "./routes/uploadI9OnboardingIDDocument/uploadI9OnboardingIDDocument";
import { uploadPayCardArt } from "./routes/uploadPayCardArt/uploadPayCardArt";
import { validateAddCardToken } from "./routes/validateAddCardToken/validateAddCardToken";
import { validateCompanyShareableLinkToken } from "./routes/validateCompanyShareableLinkToken/validateCompanyShareableLinkToken";
import { validatePartnerShareableLinkToken } from "./routes/validatePartnerShareableLinkToken/validatePartnerShareableLinkToken";
import { validateOnboardingToken } from "./routes/validateOnboardingToken/validateOnboardingToken";
import { validateWorkerShareableLinkToken } from "./routes/validateWorkerShareableLinkToken/validateWorkerShareableLinkToken";
import { verifyCompanyMicroDeposits } from "./routes/verifyCompanyMicroDeposits/verifyCompanyMicroDeposits";
import { verifyRoutingNumber } from "./routes/verifyRoutingNumber/verifyRoutingNumber";
import { submitWorkerPaycardSSNIDVerification } from "./routes/submitWorkerPaycardSSNIDVerification/submitWorkerPaycardSSNIDVerification";
import { submitWorkerPaycardSocialSecurityCardVerification } from "./routes/submitWorkerPaycardSocialSecurityCardVerification/submitWorkerPaycardSocialSecurityCardVerification";
import { postYtdSummary } from "./routes/postYtdSummary/postYtdSummary";
import { updateCardAutoCharge } from "./routes/updateCardAutoCharge/updateCardAutoCharge";
import { createInvoiceTemplate } from "./routes/createInvoiceTemplate/createInvoiceTemplate";
import { deleteInvoiceTemplate } from "./routes/deleteInvoiceTemplate/deleteInvoiceTemplate";
import { postGenerateCustomerAccountShareableLink } from "./routes/postGenerateCustomerAccountShareableLink/postGenerateCustomerAccountShareableLink";
import { postGenerateOrderPaymentLink } from "./routes/postGenerateOrderPaymentLink/postGenerateOrderPaymentLink";
import { postGenerateInvoicePaymentLink } from "./routes/postGenerateInvoicePaymentLink/postGenerateInvoicePaymentLink";
import { validateCustomerAccountShareableLinkToken } from "./routes/validateCustomerAccountShareableLinkToken/validateCustomerAccountShareableLinkToken";
import { validateOrderPaymentShareableLinkToken } from "./routes/validateOrderPaymentShareableLinkToken/validateOrderPaymentShareableLinkToken";
import { deleteFinixCard } from "./routes/deleteFinixCard/deleteFinixCard";
import { getFinixMerchant } from "./routes/getFinixMerchant/getFinixMerchant";
import { updateFinixComplianceForm } from "./routes/updateFinixComplianceForm/updateFinixComplianceForm";
import { updateInvoiceTemplate } from "./routes/updateInvoiceTemplate/updateInvoiceTemplate";
import { getInvoiceTemplateById } from "./routes/getInvoiceTemplateById/getInvoiceTemplateById";
import { getInvoiceTemplates } from "./routes/getInvoiceTemplates/getInvoiceTemplates";
import { getCompanyJobs } from "./routes/getCompanyJobs/getCompanyJobs";
import { createCompanyJob } from "./routes/createCompanyJob/createCompanyJob";
import { updateCompanyJob } from "./routes/updateCompanyJob/updateCompanyJob";
import { deleteCompanyJob } from "./routes/deleteCompanyJob/deleteCompanyJob";
import { createInvoices } from "./routes/createInvoice/createInvoices";
import { createInvoicePayout } from "./routes/createInvoicePayout/createInvoicePayout";
import { createInstantPayPayout } from "./routes/createInstantPayPayout/createInstantPayPayout";
import { createOrderPayout } from "./routes/createOrderPayout/createOrderPayout";
import { getInvoiceLineItems } from "./routes/getInvoiceLineItems/getInvoiceLineItems";
import { updateInvoice } from "./routes/updateInvoice/updateInvoice";
import { bulkUpdateInvoiceStatus } from "./routes/bulkUpdateInvoiceStatus/bulkUpdateInvoiceStatus";
import { getInvoices } from "./routes/getInvoices/getInvoices";
import { getServiceTypes } from "./routes/getServiceTypes/getServiceTypes";
import { getInvoiceStats } from "./routes/getInvoiceStats/getInvoiceStats";
import { getInvoiceBulkActionCounts } from "./routes/getInvoiceBulkActionCounts/getInvoiceBulkActionCounts";
import { getInvoicePdf } from "./routes/getInvoicePdf/getInvoicePdf";
import { trackInvoiceView } from "./routes/trackInvoiceView/trackInvoiceView";
import { getCompanyDepositRules } from "./routes/getCompanyDepositRules/getCompanyDepositRules";
import { postDepositRule } from "./routes/postDepositRule/postDepositRule";
import { updatePartnerInfo } from "./routes/updatePartnerInfo/updatePartnerInfo";
import { getPartnerBusinessDocumentUrl } from "./routes/getPartnerBusinessDocumentUrl/getPartnerBusinessDocumentUrl";
import { listPartnerBusinessDocuments } from "./routes/listPartnerBusinessDocuments/listPartnerBusinessDocuments";
import { downloadPartnerBusinessDocumentsZipInternal } from "./routes/downloadPartnerBusinessDocumentsZipInternal/downloadPartnerBusinessDocumentsZipInternal";
import { postGeneratePartnerAdditionalOwnerLink } from "./routes/postGeneratePartnerAdditionalOwnerLink/postGeneratePartnerAdditionalOwnerLink";
import { postPartnerBusinessDocuments } from "./routes/postPartnerBusinessDocuments/postPartnerBusinessDocuments";
import { postPartnerUBODocument } from "./routes/postPartnerUBODocument/postPartnerUBODocument";
import { postPartnerUBODocumentFromPersona } from "./routes/postPartnerUBODocumentFromPersona/postPartnerUBODocumentFromPersona";
import { getPartnerUBODocument } from "./routes/getPartnerUBODocument/getPartnerUBODocument";
import { signPartnerAgreements } from "./routes/signPartnerAgreements/signPartnerAgreements";
import { getPartnerAgreementPdf } from "./routes/getPartnerAgreementPdf/getPartnerAgreementPdf";
import { updateCompanyInfo } from "./routes/updateCompanyInfo/updateCompanyInfo";
import { createCompany } from "./routes/createCompany/createCompany";
import { refreshCompanyOnboardingShareableLinkToken } from "./routes/refreshCompanyOnboardingShareableLinkToken/refreshCompanyOnboardingShareableLinkToken";
import { validateCompanyOnboardingShareableLinkToken } from "./routes/validateCompanyOnboardingShareableLinkToken/validateCompanyOnboardingShareableLinkToken";
import { postGenerateCompanyOnboardingShareableLink } from "./routes/postGenerateCompanyOnboardingShareableLink/postGenerateCompanyOnboardingShareableLink";
import { postCompanyUBODocument } from "./routes/postCompanyUBODocument/postCompanyUBODocument";
import { postCompanyUBODocumentFromPersona } from "./routes/postCompanyUBODocumentFromPersona/postCompanyUBODocumentFromPersona";
import { getCompanyUBODocument } from "./routes/getCompanyUBODocument/getCompanyUBODocument";
import { postCompletePartnerOnboardingFlow } from "./routes/postCompletePartnerOnboardingFlow/postCompletePartnerOnboardingFlow";
import { updatePartnerKYCStatus } from "./routes/updatePartnerKYCStatus/updatePartnerKYCStatus";
import { postCompanyBusinessDocuments } from "./routes/postCompanyBusinessDocuments/postCompanyBusinessDocuments";
import { listCompanyBusinessDocuments } from "./routes/listCompanyBusinessDocuments/listCompanyBusinessDocuments";

export class LaForgeClient extends AbstractApiClient {
  constructor(options: IApiClientOptions) {
    super(options);
    this.configureRefreshTokenInterceptor("/refresh-token");
  }

  public readonly AddCustomerAccountContact = addCustomerAccountContact(
    this.Instance
  );
  public static AssertValidSchema: LaForgeSchemaAssertionWithParams =
    assertValidLaForgeSchema;

  public readonly ApproveCheck = approveCheck(this.Instance);
  public readonly AssertPartnerCanAccessCompany = assertPartnerCanAccessCompany(
    this.Instance
  );
  public readonly getCurrentUserAccounts = getCurrentUserAccounts(
    this.Instance
  );
  public readonly GetDoesUserExist = getDoesUserExist(this.Instance);
  public readonly CreateAccount = createAccount(this.Instance);
  public readonly selectAccount = selectAccount(this.Instance);
  public readonly submitEmailConfirmation = submitEmailConfirmation(
    this.Instance
  );
  public readonly CalculateCharges = calculateCharges(this.Instance);
  public readonly GetChargesPolicies = getChargesPolicies(this.Instance);
  public readonly GetCharge = getCharge(this.Instance);
  public readonly CheckCookie = checkCookie(this.Instance);
  public readonly Company = company(this.Instance);
  public readonly CompleteEmployerOnboardingFlow =
    completeEmployerOnboardingFlow(this.Instance);
  public readonly CreateCompanyBankAccount = createCompanyBankAccount(
    this.Instance
  );
  public readonly CreateCompanyMicroDeposits = createCompanyMicroDeposits(
    this.Instance
  );
  public readonly CreateCompanyTaxDocument = createCompanyTaxDocument(
    this.Instance
  );
  public readonly CreateCompanyTransaction = createCompanyTransaction(
    this.Instance
  );
  public readonly CreateContractor = createContractor(this.Instance);
  public readonly CreateContractorPayCard = createContractorPayCard(
    this.Instance
  );
  public readonly CreateContractorPayment = createContractorPayment(
    this.Instance
  );
  public readonly CreatePaymentItem = createPaymentItem(this.Instance);
  public readonly CreateCustomerAccount = createCustomerAccount(this.Instance);
  public readonly CreateEmployee = createEmployee(this.Instance);
  public readonly CreateEmployeePayCard = createEmployeePayCard(this.Instance);
  public readonly CreateEmployeeChecksFromBullhornCsv =
    createEmployeeChecksFromBullhornCsv(this.Instance);
  public readonly CreateLaborPoster = createLaborPoster(this.Instance);
  public readonly CreateLaborPosterVersion = createLaborPosterVersion(
    this.Instance
  );
  public readonly CreatePayment = createPayment(this.Instance);
  public readonly CreatePayrollRunChecks = createPayrollRunChecks(
    this.Instance
  );
  public readonly CreateVeriffSession = createVeriffSession(this.Instance);
  public readonly GetAdminReviewFlags = getAdminReviewFlags(this.Instance);
  public readonly CreateWalletTransaction = createWalletTransaction(
    this.Instance
  );
  public readonly CreateWorkerWallet = createWorkerWallet(this.Instance);
  public readonly CreateWorkerAstraUser = createWorkerAstraUser(this.Instance);
  public readonly DeleteCheck = deleteCheck(this.Instance);
  public readonly DeleteContractorPayment = deleteContractorPayment(
    this.Instance
  );
  public readonly DeletePushToCardUserCard = deletePushToCardUserCard(
    this.Instance
  );
  public readonly DeleteMember = deleteMember(this.Instance);
  public readonly DownloadCompanyTaxDocumentUrl = downloadCompanyTaxDocumentUrl(
    this.Instance
  );
  public readonly DownloadPoaDocument = downloadPoaDocument(this.Instance);
  public readonly DownloadLaborPoster = downloadLaborPoster(this.Instance);
  public readonly Features = features(this.Instance);
  public readonly FinishHomeSetup = finishHomeSetup(this.Instance);
  public readonly GenerateDocumentGetUrl = generateDocumentGetUrl(
    this.Instance
  );
  public readonly GenerateIdGetUrl = generateIdGetUrl(this.Instance);
  public readonly GenerateLogoGetUrl = generateLogoGetUrl(this.Instance);
  public readonly GenerateLogoPutUrl = generateLogoPutUrl(this.Instance);
  public readonly GenerateCustomerAccountOnboardingLink =
    generateCustomerAccountOnboardingLink(this.Instance);
  public readonly GetActivePayrollRuns = getActivePayrollRuns(this.Instance);
  public readonly GetNextRegularRun = getNextRegularRun(this.Instance);
  public readonly GetAdminInfo = getAdminInfo(this.Instance);
  public readonly GetCheckCsvTemplate = getCheckCsvTemplate(this.Instance);
  public readonly GetCheckDates = getCheckDates(this.Instance);
  public readonly GetCheckDatesReportingDetails = getCheckDatesReportingDetails(
    this.Instance
  );
  public readonly GetCompanyAccounts = getCompanyAccounts(this.Instance);
  public readonly GetCompanyTaskDefinitions = getCompanyTaskDefinitions(
    this.Instance
  );
  public readonly GetCompanyDebits = getCompanyDebits(this.Instance);
  public readonly GetCompanyTaxDocument = getCompanyTaxDocument(this.Instance);
  public readonly GetCompanyTaxDocuments = getCompanyTaxDocuments(
    this.Instance
  );
  public readonly GetCompanyTaxRequirements = getCompanyTaxRequirements(
    this.Instance
  );
  public readonly GetCompanyMFATypes = getCompanyMFATypes(this.Instance);
  public readonly GetContractorInfo = getContractorInfo(this.Instance);
  public readonly GetContractorDeductionTemplates =
    getContractorDeductionTemplates(this.Instance);
  public readonly CreateContractorDeductionTemplate =
    createContractorDeductionTemplate(this.Instance);
  public readonly UpdateContractorDeductionTemplate =
    updateContractorDeductionTemplate(this.Instance);
  public readonly ArchiveContractorDeductionTemplate =
    archiveContractorDeductionTemplate(this.Instance);
  public readonly PostContractorPaymentDeduction =
    postContractorPaymentDeduction(this.Instance);
  public readonly DeleteContractorPaymentDeduction =
    deleteContractorPaymentDeduction(this.Instance);
  public readonly PatchContractorPaymentDeduction =
    patchContractorPaymentDeduction(this.Instance);
  public readonly GetDirectPayments = getDirectPayments(this.Instance);
  public readonly GetFinixMerchant = getFinixMerchant(this.Instance);
  public readonly GetQuickviewContractorInfo = getQuickviewContractorInfo(
    this.Instance
  );
  public readonly GetContractorInfoByPayload = getContractorInfoByPayload(
    this.Instance
  );
  public readonly GetContractorPayCards = getContractorPayCards(this.Instance);
  public readonly GetContractorPayment = getContractorPayment(this.Instance);
  public readonly GetSingleContractorPaymentAsContractor =
    getSingleContractorPaymentAsContractor(this.Instance);
  public readonly GetContractorPayments = getContractorPayments(this.Instance);
  public readonly GetContractorPaymentsAsContractor =
    getContractorPaymentsAsContractor(this.Instance);
  public readonly GetContractorPaymentGroupById = getContractorPaymentGroupById(
    this.Instance
  );
  public readonly GetContractorPaymentGroups = getContractorPaymentGroups(
    this.Instance
  );
  public readonly GetCustomerAccounts = getCustomerAccounts(this.Instance);
  public readonly GetCustomReportConfigs = getCustomReportConfigs(
    this.Instance
  );
  public readonly GetDeductionTypeConfig = getDeductionTypeConfig(
    this.Instance
  );
  public readonly GetDeductionTemplateSummary = getDeductionTemplateSummary(
    this.Instance
  );
  public readonly GetContractors = getContractors(this.Instance);
  public readonly GetDocuments = getDocuments(this.Instance);
  public readonly GetOrders = getOrders(this.Instance);
  public readonly GetOrderStatistics = getOrderStatistics(this.Instance);
  public readonly GetCurrentUser = getCurrentUser(this.Instance);
  public readonly GetEmployeeCheck = getEmployeeCheck(this.Instance);
  public readonly GetEmployeeCheckDetails = getEmployeeCheckDetails(
    this.Instance
  );
  public readonly GetEmployeeCheckInfo = getEmployeeCheckInfo(this.Instance);
  public readonly GetEmployeeChecks = getEmployeeChecks(this.Instance);
  public readonly GetEmployeeCheckDeductions = getEmployeeCheckDeductions(
    this.Instance
  );
  public readonly GetEmployeeCheckDisbursementEvents =
    getEmployeeCheckDisbursementEvents(this.Instance);
  public readonly GetEmployeeChecksByPayload = getEmployeeChecksByPayload(
    this.Instance
  );
  public readonly GetEmployeePayCards = getEmployeePayCards(this.Instance);
  public readonly CreateAppleWalletProvision = createAppleWalletProvision(
    this.Instance
  );
  public readonly CreateGoogleWalletProvision = createGoogleWalletProvision(
    this.Instance
  );
  public readonly GetEmployeeReportingPeriods = getEmployeeReportingPeriods(
    this.Instance
  );
  public readonly GetEmployerCheckById = getEmployerCheckById(this.Instance);
  public readonly GetEmployerCheckDisbursementEvents =
    getEmployerCheckDisbursementEvents(this.Instance);
  public readonly GetEmployerCheckInternal = getEmployerCheckInternal(
    this.Instance
  );
  public readonly GetGovernmentIdUrls = getGovernmentIdUrls(this.Instance);
  public readonly GetGuestInfo = getGuestInfo(this.Instance);
  public readonly GetInternalUserInfo = getInternalUserInfo(this.Instance);
  public readonly GetJobs = getJobs(this.Instance);
  public readonly GetCompanyJobs = getCompanyJobs(this.Instance);
  public readonly CreateCompanyJob = createCompanyJob(this.Instance);
  public readonly UpdateCompanyJob = updateCompanyJob(this.Instance);
  public readonly DeleteCompanyJob = deleteCompanyJob(this.Instance);
  public readonly GetKYC = getKYC(this.Instance);
  public readonly GetMembers = getMembers(this.Instance);
  public readonly GetMyEmployerChecks = getMyEmployerChecks(this.Instance);
  public readonly GetMyContractorPayments = getMyContractorPayments(
    this.Instance
  );
  public readonly GetContractorsGrossPay = getContractorsGrossPay(
    this.Instance
  );
  public readonly GetLaborPoster = getLaborPoster(this.Instance);
  public readonly GetLaborPosters = getLaborPosters(this.Instance);
  public readonly GetMyWorkers = getMyWorkers(this.Instance);
  public readonly GetMyRecentlyOnboardedContractors =
    getMyRecentlyOnboardedContractors(this.Instance);
  public readonly GetMyRecentlyOnboardedWorkers = getMyRecentlyOnboardedWorkers(
    this.Instance
  );
  public readonly GetNextRegularPayrollRun = getNextRegularPayrollRun(
    this.Instance
  );
  public readonly GetOnboardingAuthLink = getOnboardingAuthLink(this.Instance);
  public readonly GetOnboardingInfo = getOnboardingInfo(this.Instance);
  public readonly GetOnboardingLink = getOnboardingLink(this.Instance);
  public readonly GetPayCard = getPayCard(this.Instance);
  public readonly GetContractorPaycardStatement = getContractorPaycardStatement(
    this.Instance
  );
  public readonly GetContractorPaycardStatements =
    getContractorPaycardStatements(this.Instance);
  public readonly GetEmployeePaycardStatement = getEmployeePaycardStatement(
    this.Instance
  );
  public readonly GetVeriffDecision = getVeriffDecision(this.Instance);
  public readonly GetPersonaDecision = getPersonaDecision(this.Instance);
  public readonly GetEmployeePaycardStatements = getEmployeePaycardStatements(
    this.Instance
  );
  public readonly GetPayCardToken = getPayCardToken(this.Instance);
  public readonly GetPaycardTransaction = getPaycardTransaction(this.Instance);
  public readonly GetPayCardTransactions = getPayCardTransactions(
    this.Instance
  );
  public readonly GetPayCardArt = getPayCardArt(this.Instance);
  public readonly UploadPayCardArt = uploadPayCardArt(this.Instance);
  public readonly GetPaycardEnrollmentActionRequired =
    getPaycardEnrollmentActionRequired(this.Instance);
  public readonly GetPendingShifts = getPendingShifts(this.Instance);
  public readonly GetPendingChecks = getPendingChecks(this.Instance);
  public readonly GetPermissions = getPermissions(this.Instance);
  public readonly GetPoaDocuments = getPoaDocuments(this.Instance);
  public readonly GetPartnerBusinessDocumentUrl = getPartnerBusinessDocumentUrl(
    this.Instance
  );
  public readonly ListPartnerBusinessDocuments = listPartnerBusinessDocuments(
    this.Instance
  );
  public readonly DownloadPartnerBusinessDocumentsZipInternal =
    downloadPartnerBusinessDocumentsZipInternal(this.Instance);
  public readonly PostPartnerBusinessDocuments = postPartnerBusinessDocuments(
    this.Instance
  );
  public readonly GetPartnerSecurityDocumentUrl = getPartnerSecurityDocumentUrl(
    this.Instance
  );
  public readonly ListPartnerSecurityDocuments = listPartnerSecurityDocuments(
    this.Instance
  );
  public readonly GetPreviewChecks = getPreviewChecks(this.Instance);
  public readonly GetReportsStatus = getReportsStatus(this.Instance);
  public readonly GetSecondaryJWT = getSecondaryJWT(this.Instance);
  public readonly GetStateTaxConfig = getStateTaxConfig(this.Instance);
  public readonly GetLocalTaxTypes = getLocalTaxTypes(this.Instance);
  public readonly GetSubEmployeeChecks = getSubEmployeeChecks(this.Instance);
  public readonly GetTaxSetupInfo = getTaxSetupInfo(this.Instance);
  public readonly GetTransactions = getTransactions(this.Instance);
  public readonly GetTransactionByConnectionID = getTransactionByConnectionID(
    this.Instance
  );
  public readonly GetUpcomingCheck = getUpcomingChecks(this.Instance);
  public readonly GetUserInfo = getUserInfo(this.Instance);
  public readonly GetVeriffIds = getVeriffIds(this.Instance);
  public readonly GetWallets = getWallets(this.Instance);
  public readonly GetWalletStatistics = getWalletStatistics(this.Instance);
  public readonly GetWalletTransactions = getWalletTransactions(this.Instance);
  public readonly GetWLAlerts = getWLAlerts(this.Instance);
  public readonly GetWLHostedConfig = getWLHostedConfig(this.Instance);
  public readonly GetWLInfo = getWLInfo(this.Instance);
  public readonly GetWLInfoById = getWLInfoById(this.Instance);
  public readonly GetWorker = getWorker(this.Instance);
  public readonly GetWorkerInfoByPayload = getWorkerInfoByPayload(
    this.Instance
  );
  public readonly GetWorkerIds = getWorkerIds(this.Instance);
  public readonly GetWorkerInfo = getWorkerInfo(this.Instance);
  public readonly GetWorkerTasks = getWorkerTasks(this.Instance);
  public readonly GetWorkerTasksStatus = getWorkerTasksStatus(this.Instance);
  public readonly GetWorkerWallets = getWorkerWallets(this.Instance);
  public readonly GetWorkerWalletTransactions = getWorkerWalletTransactions(
    this.Instance
  );
  public readonly GetEmployeePaycardDisclosures = getEmployeePaycardDisclosures(
    this.Instance
  );
  public readonly GetContractorPaycardDisclosures =
    getContractorPaycardDisclosures(this.Instance);
  public readonly GetQuickviewWorkerInfo = getQuickviewWorkerInfo(
    this.Instance
  );

  public readonly InviteMember = inviteMember(this.Instance);
  public readonly Login = login(this.Instance);
  public readonly Logout = logout(this.Instance);
  public readonly PatchTaxSetupInfo = patchTaxSetupInfo(this.Instance);
  public readonly RequestEmployeePaycards = requestEmployeePaycards(
    this.Instance
  );
  public readonly RequestContractorPaycards = requestContractorPaycards(
    this.Instance
  );
  public readonly PostCashRequirements = postCashRequirements(this.Instance);
  public readonly PostCompanyDebits = postCompanyDebits(this.Instance);
  public readonly PostCreatePayrollRun = postCreatePayrollRun(this.Instance);
  public readonly PostCustomPayrollJournal = postCustomPayrollJournal(
    this.Instance
  );
  public readonly GetCheckPDF = getCheckPDF(this.Instance);
  public readonly PostGeneratePaystubFile = postGeneratePaystubFile(
    this.Instance
  );
  public readonly PostGarnishmentDocument = postGarnishmentDocument(
    this.Instance
  );
  public readonly DownloadGarnishmentDocument = downloadGarnishmentDocument(
    this.Instance
  );
  public readonly PostDeductionsSummary = postDeductionsSummary(this.Instance);
  public readonly PostYtdSummary = postYtdSummary(this.Instance);
  public readonly PostEmployees = postEmployees(this.Instance);
  public readonly PostI9EVerifySummary = postI9EVerifySummary(this.Instance);
  public readonly PostKycSummary = postKycSummary(this.Instance);
  public readonly PostLaborAllocation = postLaborAllocation(this.Instance);
  public readonly PostLaborAllocationXero = postLaborAllocationXero(
    this.Instance
  );
  public readonly PostPaymentSummary = postPaymentSummary(this.Instance);
  public readonly PostPayrollJournal = postPayrollJournal(this.Instance);
  public readonly PostCustomReport = postCustomReport(this.Instance);
  public readonly PostSignNmbrRequest = postSignNmbrRequest(this.Instance);
  public readonly PostPaystub = postPaystub(this.Instance);
  public readonly PostPreviewCheckData = postPreviewCheckData(this.Instance);
  public readonly PostWorkerSummary = postWorkerSummary(this.Instance);
  public readonly ReplaceI9WorkerLocation = replaceI9WorkerLocation(
    this.Instance
  );
  public readonly ReplaceI9AuthRepLocation = replaceI9AuthRepLocation(
    this.Instance
  );
  public readonly RollKey = rollKey(this.Instance);
  public readonly SaveEmployerOnboardingTerms = saveEmployerOnboardingTerms(
    this.Instance
  );
  public readonly SaveStateTaxParams = saveStateTaxParams(this.Instance);
  public readonly SendContractorOnboardingLink = sendContractorOnboardingLink(
    this.Instance
  );
  public readonly SetFaviconStatus = setFaviconStatus(this.Instance);
  public readonly SetLogoStatus = setLogoStatus(this.Instance);
  public readonly SendOnboardingLink = sendOnboardingLink(this.Instance);
  public readonly TestCheckCreatedWebhook = testCheckCreatedWebhook(
    this.Instance
  );
  public readonly TestCheckProcessedWebhook = testCheckProcessedWebhook(
    this.Instance
  );
  public readonly TestCheckProcessedLeanWebhook = testCheckProcessedLeanWebhook(
    this.Instance
  );
  public readonly TestContractorPaymentWebhook = testContractorPaymentWebhook(
    this.Instance
  );
  public readonly TestContractorWebhook = testContractorWebhook(this.Instance);
  public readonly TestCreationWebhook = testCreationWebhook(this.Instance);
  public readonly TestEmployeeCheckWebhook = testEmployeeCheckWebhook(
    this.Instance
  );
  public readonly TestEmployeeWebhook = testEmployeeWebhook(this.Instance);
  public readonly TestEmployerOnboardingWebhook = testEmployerOnboardingWebhook(
    this.Instance
  );
  public readonly TestEmployerUpdatedWebhook = testEmployerUpdatedWebhook(
    this.Instance
  );
  public readonly TestReportWebhook = testReportWebhook(this.Instance);
  public readonly TestEVerifyWebhook = testEVerifyWebhook(this.Instance);
  public readonly TestOnboardingWebhook = testOnboardingWebhook(this.Instance);
  public readonly TestI9Webhook = testI9Webhook(this.Instance);
  public readonly TestShiftWebhook = testShiftWebhook(this.Instance);
  public readonly TestCustomerAccountOnboardingWebhook =
    testCustomerAccountOnboardingWebhook(this.Instance);
  public readonly TestCustomerAccountUpdatedWebhook =
    testCustomerAccountUpdatedWebhook(this.Instance);
  public readonly Token = token(this.Instance);
  public readonly TransferPaycardFunds = transferPaycardFunds(this.Instance);
  public readonly UNSAFE__ForceExpireCookies = UNSAFE__forceExpireCookies(
    this.Instance
  );

  public readonly UploadIDVerification = uploadIDVerification(this.Instance);

  public readonly UpdateAdminInfo = updateAdminInfo(this.Instance);
  public readonly UpdateBankAccount = updateBankAccount(this.Instance);
  public readonly UpdateBankAccountAsWorker = updateBankAccountAsWorker(
    this.Instance
  );
  public readonly UpdateCompany = updateCompany(this.Instance);
  public readonly UpdateContractor = updateContractor(this.Instance);
  public readonly UpdateContractorPayment = updateContractorPayment(
    this.Instance
  );
  public readonly UpdatePaymentItem = updatePaymentItem(this.Instance);
  public readonly DeletePaymentItem = deletePaymentItem(this.Instance);
  public readonly UpdateCustomerAccount = updateCustomerAccount(this.Instance);
  public readonly UpdateGuestInfo = updateGuestInfo(this.Instance);
  public readonly UpdateEmployee = updateEmployee(this.Instance);
  public readonly UpdateEmployeeAsCompany = updateEmployeeAsCompany(
    this.Instance
  );
  public readonly UpdateCompanyTaxParameter = updateCompanyTaxParameter(
    this.Instance
  );
  public readonly UpdatePartner = updatePartner(this.Instance);
  public readonly UpdatePartnerQuestionnaire = updatePartnerQuestionnaire(
    this.Instance
  );
  public readonly UpdatePaycard = updatePaycard(this.Instance);
  public readonly UpdateTaxParameters = uploadTaxParameters(this.Instance);
  public readonly UpdateUserInfo = updateUserInfo(this.Instance);
  public readonly CreateCompanyLocation = createCompanyLocation(this.Instance);
  public readonly GetCompanyLocations = getCompanyLocations(this.Instance);
  public readonly UpdateCompanyLocation = updateCompanyLocation(this.Instance);
  public readonly GetDepartments = getDepartments(this.Instance);
  public readonly PostDepartments = postDepartments(this.Instance);
  public readonly PatchDepartments = patchDepartments(this.Instance);
  public readonly DeleteDepartment = deleteDepartment(this.Instance);
  public readonly GetCompanyDepositRules = getCompanyDepositRules(
    this.Instance
  );
  public readonly PostDepositRule = postDepositRule(this.Instance);
  public readonly PatchDepositRule = patchDepositRule(this.Instance);
  public readonly DeleteDepositRule = deleteDepositRule(this.Instance);
  public readonly UpdateCompanyVeriffToken = updateCompanyVeriffToken(
    this.Instance
  );
  public readonly GetCompanyVeriffToken = getCompanyVeriffToken(this.Instance);
  public readonly UpdateCompanyTaskDefinitions = updateCompanyTaskDefinitions(
    this.Instance
  );
  public readonly UpdateCompanyTaxDocumentById = updateCompanyTaxDocumentById(
    this.Instance
  );
  public readonly UpdateCheckCreatedWebhook = updateCheckCreatedWebhook(
    this.Instance
  );
  public readonly UpdateCheckProcessedWebhook = updateCheckProcessedWebhook(
    this.Instance
  );
  public readonly UpdateCheckProcessedLeanWebhook =
    updateCheckProcessedLeanWebhook(this.Instance);
  public readonly UpdateContractorPaymentWebhook =
    updateContractorPaymentWebhook(this.Instance);
  public readonly UpdateContractorWebhook = updateContractorWebhook(
    this.Instance
  );
  public readonly UpdateCreationWebhook = updateCreationWebhook(this.Instance);
  public readonly UpdateEmployeeWebhook = updateEmployeeWebhook(this.Instance);
  public readonly UpdateEmployeeCheckWebhook = updateEmployeeCheckWebhook(
    this.Instance
  );
  public readonly UpdateEmployerOnboardingWebhook =
    updateEmployerOnboardingWebhook(this.Instance);
  public readonly UpdateEmployerUpdatedWebhook = updateEmployerUpdatedWebhook(
    this.Instance
  );
  public readonly UpdateEVerifyWebhook = updateEVerifyWebhook(this.Instance);
  public readonly UpdateLaborPoster = updateLaborPoster(this.Instance);
  public readonly UpdateWebhook = updateWebhook(this.Instance);
  public readonly TestWebhook = testWebhook(this.Instance);
  public readonly UpdateOnboardingWebhook = updateOnboardingWebhook(
    this.Instance
  );
  public readonly UpdateI9Webhook = updateI9Webhook(this.Instance);
  public readonly UpdateReportWebhook = updateReportWebhook(this.Instance);
  public readonly UpdateCustomerAccountOnboardingWebhook =
    updateCustomerAccountOnboardingWebhook(this.Instance);
  public readonly UpdateCustomerAccountUpdatedWebhook =
    updateCustomerAccountUpdatedWebhook(this.Instance);
  public readonly UpdateEmployeeCheckByID = updateEmployeeCheckByID(
    this.Instance
  );
  public readonly UpdateShift = updateShift(this.Instance);
  public readonly UpdateShiftWebhook = updateShiftWebhook(this.Instance);
  public readonly UpdateWLInfo = updateWLInfo(this.Instance);
  public readonly UpdateEmployeeAsSelf = updateEmployeeAsSelf(this.Instance);
  public readonly UpdateImageAws = updateImageAws(this.Instance);
  public readonly UpdateFileAws = updateFileAws(this.Instance);
  public readonly Whoami = whoami(this.Instance);
  public readonly GetClosestCheckDate = getClosestCheckDate(this.Instance);
  public readonly GetPayrollRunById = getPayrollRunById(this.Instance);
  public readonly GetPayrollRunEmployees = getPayrollRunEmployees(
    this.Instance
  );
  public readonly GetPayrollRun = getPayrollRun(this.Instance);
  public readonly GetPayrollRuns = getPayrollRuns(this.Instance);
  public readonly GetPayrollChecks = getPayrollChecks(this.Instance);
  public readonly UpdateCheck = updateCheck(this.Instance);
  public readonly DeleteShift = deleteShift(this.Instance);
  public readonly UpdatePayrollRun = updatePayrollRun(this.Instance);
  public readonly GetCheckPreview = getCheckPreview(this.Instance);
  public readonly PostManageBulkDeductions = postManageBulkDeductions(
    this.Instance
  );
  public readonly FetchCheckDetails = fetchCheckDetails(this.Instance);
  public readonly SubmitShift = submitShift(this.Instance);
  public readonly CreateEmployeeCheck = createEmployeeCheck(this.Instance);
  public readonly GetChecksExistAlert = getChecksExistAlert(this.Instance);
  public readonly SubmitPayrollRun = submitPayrollRun(this.Instance);
  public readonly CreateOrder = createOrder(this.Instance);
  public readonly UpdateOrder = updateOrder(this.Instance);
  public readonly SubmitOrder = submitOrder(this.Instance);
  public readonly ToggleOrderStatus = toggleOrderStatus(this.Instance);
  public readonly CreatePayrollRun = createPayrollRun(this.Instance);
  public readonly PostParseCheckCSV = postParseChecksCSV(this.Instance);
  public readonly PostParsePaymentsCSV = postParsePaymentsCsv(this.Instance);
  public readonly GetReportingPeriodsByFrequency =
    getReportingPeriodsByFrequency(this.Instance);
  public readonly DeletePayrollRun = deletePayrollRun(this.Instance);
  public readonly SetUserPayrollRunSettings = setUserPayrollRunSettings(
    this.Instance
  );
  public readonly ResendFax = resendFax(this.Instance);
  public readonly GetFaxes = getFaxes(this.Instance);
  public readonly GetNewHireReportingSummary = getNewHireReportingSummary(
    this.Instance
  );
  public readonly GetNewHireWorkers = getNewHireWorkers(this.Instance);
  public readonly PatchNewHireWorkerStatus = patchNewHireWorkerStatus(
    this.Instance
  );
  public readonly GenerateNewHireFileUrl = generateNewHireFileUrl(
    this.Instance
  );
  public readonly GetFormList = getFormList(this.Instance);
  public readonly GetFormTemplate = getFormTemplate(this.Instance);
  public readonly GetFormSubmissions = getFormSubmissions(this.Instance);
  public readonly PostForm = postForm(this.Instance);
  public readonly PostFormRenderPDF = postFormRenderPDF(this.Instance);
  public readonly PostFormRenderJSON = postFormRenderJSON(this.Instance);
  public readonly GetEmployeeRequirementsLinks = getEmployeeRequirementsLinks(
    this.Instance
  );
  public readonly UpdateEmployeeRequirementCreatedWebhook =
    updateEmployeeRequirementCreatedWebhook(this.Instance);

  public readonly TestEmployeeRequirementCreatedWebhook =
    testEmployeeRequirementCreatedWebhook(this.Instance);

  public readonly UpdateEmployeeRequirementUpdatedWebhook =
    updateEmployeeRequirementUpdatedWebhook(this.Instance);

  public readonly TestEmployeeRequirementUpdatedWebhook =
    testEmployeeRequirementUpdatedWebhook(this.Instance);

  public readonly VerifyRoutingNumber = verifyRoutingNumber(this.Instance);
  public readonly CreateBankAccount = createBankAccount(this.Instance);
  public readonly CreateBankAccountAsWorker = createBankAccountAsWorker(
    this.Instance
  );
  public readonly CreateBankAccountAndSignForms = createBankAccountAndSignForms(
    this.Instance
  );
  public readonly RemoveAccountMembership = removeAccountMembership(
    this.Instance
  );
  public readonly SaveCompanySignature = saveCompanySignature(this.Instance);
  public readonly PostTelemetry = postTelemetry(this.Instance);
  public readonly GetWageViolations = getWageViolations(this.Instance);
  public readonly GetI9OnboardingInfo = getI9OnboardingInfo(this.Instance);
  public readonly GetWorkerI9Data = getWorkerI9Data(this.Instance);
  public readonly GetWorkerI9MetricsAndStats = getWorkerI9MetricsAndStats(
    this.Instance
  );
  public readonly GetEmployeeI9Documents = getEmployeeI9Documents(
    this.Instance
  );
  public readonly PostManualUploadI9Document = postManualUploadI9Document(
    this.Instance
  );
  public readonly PostUploadI9Document = postUploadI9Document(this.Instance);
  public readonly UpdateI9OnboardingInfo = updateI9OnboardingInfo(
    this.Instance
  );
  public readonly UploadI9OnboardingIDDocument = uploadI9OnboardingIDDocument(
    this.Instance
  );
  public readonly GetInfoForAuthorizedRepresentative =
    getInfoForAuthorizedRepresentative(this.Instance);
  public readonly UpdateI9OnboardingInfoAsAuthorizedRepresentative =
    updateI9OnboardingInfoAsAuthorizedRepresentative(this.Instance);
  public readonly GetI9ReviewProgress = getI9ReviewProgress(this.Instance);
  public readonly UpdateI9AdminReview = updateI9AdminReview(this.Instance);
  public readonly GenerateFileGetUrl = generateFileGetUrl(this.Instance);
  public readonly GenerateFilePutUrl = generateFilePutUrl(this.Instance);

  public readonly GetCustomPaperworkTemplates = getCustomPaperworkTemplates(
    this.Instance
  );
  public readonly CreateCustomPaperwork = createCustomPaperwork(this.Instance);
  public readonly FetchCustomPaperwork = fetchCustomPaperwork(this.Instance);
  public readonly UpdateCustomPaperwork = updateCustomPaperwork(this.Instance);
  public readonly UpdateCustomerAccountInfo = updateCustomerAccountInfo(
    this.Instance
  );
  public readonly GetCustomerAccountOnboardingInfo =
    getCustomerAccountOnboardingInfo(this.Instance);
  public readonly ValidateOnboardingToken = validateOnboardingToken(
    this.Instance
  );
  public readonly CreateFundingSource = createFundingSource(this.Instance);

  public readonly GetTransactionEvents = getTransactionEvents(this.Instance);
  public readonly GetHeadcount = getHeadcount(this.Instance);
  public readonly GetWorkerCount = getWorkerCount(this.Instance);

  public readonly GetEmbeddingSignedToken = getEmbeddingSignedToken(
    this.Instance
  );

  public readonly GetPaperworkTemplates = getPaperworkTemplate(this.Instance);
  public readonly PostPaperworkTemplate = postPaperworkTemplate(this.Instance);
  public readonly PutPaperworkTemplate = putPaperworkTemplate(this.Instance);
  public readonly PatchPaperworkTemplate = patchPaperworkTemplate(
    this.Instance
  );
  public readonly ArchivePaperworkTemplate = archivePaperworkTemplate(
    this.Instance
  );
  public readonly MigrateEmployeeData = migrateEmployeeData(this.Instance);
  public readonly MigrateContractorData = migrateContractorData(this.Instance);
  public readonly MigrateEmployeeTaxParamsData = migrateEmployeeTaxParamsData(
    this.Instance
  );
  public readonly MigrateContractorPayment = migrateContractorPayment(
    this.Instance
  );
  public readonly GenerateFilesPutUrl = generateFilesPutUrl(this.Instance);
  public readonly GetCompanyKybDocuments = getCompanyKybDocuments(
    this.Instance
  );
  public readonly PostAttachEVerifyDocumentToWorker =
    postAttachEVerifyDocumentToWorker(this.Instance);
  public readonly PostArchiveWorkerBankAccount = postArchiveWorkerBankAccount(
    this.Instance
  );
  public readonly PostKickBackWorkerI9 = postKickBackWorkerI9(this.Instance);
  public readonly PostSendPushNotifications = postSendPushNotifications(
    this.Instance
  );
  public readonly GetBulkEVerifyPublicCaseStatuses =
    getBulkEVerifyPublicCaseStatuses(this.Instance);
  public readonly UpdateEVerifyPublicCaseStatus = updateEVerifyPublicCaseStatus(
    this.Instance
  );
  public readonly PostResolveEVerifyPendingReferral =
    postResolveEVerifyPendingReferral(this.Instance);
  public readonly PostResolveEVerifyFinalNonConfirmation =
    postResolveEVerifyFinalNonConfirmation(this.Instance);
  public readonly DownloadEVerifyNotice = downloadEVerifyNotice(this.Instance);
  public readonly GetPendingEVerifyActionByAdmin =
    getPendingEVerifyActionByAdmin(this.Instance);
  public readonly VerifyMicroDeposits = verifyMicroDeposits(this.Instance);
  public readonly GetI9OnboardingLink = getI9OnboardingLink(this.Instance);
  public readonly SendI9OnboardingLink = sendI9OnboardingLink(this.Instance);
  public readonly GetBankAccount = getBankAccount(this.Instance);
  public readonly PostRetryTransaction = postRetryTransaction(this.Instance);
  public readonly CreateAttribute = createAttribute(this.Instance);
  public readonly DeleteAttribute = deleteAttribute(this.Instance);
  public readonly ReadAttribute = readAttribute(this.Instance);
  public readonly UpdateAttribute = updateAttribute(this.Instance);
  public readonly QueryAttributes = queryAttributes(this.Instance);
  public readonly QueryWorkerAttributes = queryWorkerAttributes(this.Instance);
  public readonly CreateOrUpdateApplyAttributes = createOrUpdateApplyAttribute(
    this.Instance
  );
  public readonly CreateRuleSet = createRuleSet(this.Instance);
  public readonly ListRuleSets = listRuleSets(this.Instance);
  public readonly GetRuleSet = getRuleSet(this.Instance);
  public readonly UpdateFilterRule = updateFilterRule(this.Instance);
  public readonly UpdateGroupOperator = updateGroupOperator(this.Instance);
  public readonly MoveRule = moveRule(this.Instance);
  public readonly RemoveRule = removeRule(this.Instance);
  public readonly EvaluateRuleSet = evaluateRuleSet(this.Instance);
  public readonly DeleteRuleSet = deleteRuleSet(this.Instance);
  public readonly AddFilterRule = addFilterRule(this.Instance);
  public readonly AddGroupRule = addGroupRule(this.Instance);
  public readonly GetCurrentState = getCurrentState(this.Instance);

  public readonly PostGenerateW4UpdateLink = postGenerateW4UpdateLink(
    this.Instance
  );
  public readonly GetCanadianPayrollBusinessEntity =
    getCanadianPayrollBusinessEntity(this.Instance);
  public readonly PatchCanadianPayrollBusinessEntity =
    patchCanadianPayrollBusinessEntity(this.Instance);
  public readonly PostGenerateCanadianPayrollOnboardingLink =
    postGenerateCanadianPayrollOnboardingLink(this.Instance);
  public readonly PostUpdateCanadianPayrollBusinessEntity =
    postUpdateCanadianPayrollBusinessEntity(this.Instance);
  public readonly PostGenerateCompanyShareableLink =
    postGenerateCompanyShareableLink(this.Instance);
  public readonly PostGenerateShareableLink = postGenerateShareableLink(
    this.Instance
  );
  public readonly PostGenerateSSEToken = postGenerateSSEToken(this.Instance);
  public readonly PostTriggerBulkPreviewChecks = postTriggerBulkPreviewChecks(
    this.Instance
  );
  public readonly SwitchCheckToPending = switchCheckToPending(this.Instance);
  public readonly ValidateCompanyShareableLinkToken =
    validateCompanyShareableLinkToken(this.Instance);
  public readonly ValidatePartnerShareableLinkToken =
    validatePartnerShareableLinkToken(this.Instance);
  public readonly ValidateWorkerShareableLinkToken =
    validateWorkerShareableLinkToken(this.Instance);
  public readonly GetFrigadeClient = getFrigadeClient(this.Instance);
  public readonly SubmitPersonaVerification = submitPersonaVerification(
    this.Instance
  );
  public readonly SubmitWorkerAccountInfo = submitWorkerAccountInfo(
    this.Instance
  );
  public readonly OnboardCustomerAccount = onboardCustomerAccount(
    this.Instance
  );

  public readonly GetInternationalForm = getInternationalForm(this.Instance);
  public readonly TestWorkerPaycardOnboardingWebhook =
    testWorkerPaycardOnboardingWebhook(this.Instance);
  public readonly UpdateWorkerPaycardOnboardingWebhook =
    updateWorkerPaycardOnboardingWebhook(this.Instance);
  public readonly EnableWorkerInstantPay = enableWorkerInstantPay(
    this.Instance
  );
  public readonly GetWorkerAstraUser = getWorkerAstraUser(this.Instance);
  public readonly GetWorkerAstraCard = getWorkerAstraCard(this.Instance);
  public readonly UpdateUserCard = updateUserCard(this.Instance);
  public readonly PostPushNotificationToken = postPushNotificationToken(
    this.Instance
  );
  public readonly VerifyCompanyMicroDeposits = verifyCompanyMicroDeposits(
    this.Instance
  );
  public readonly GetFurtherActionNoticeURLsByWorkerIDs =
    getFurtherActionNoticeURLsByWorkerIDs(this.Instance);
  public readonly SignCompanyAgreements = signCompanyAgreements(this.Instance);
  public readonly GetCompaniesUnsignedAgreementsStatus =
    getCompaniesUnsignedAgreementsStatus(this.Instance);
  public readonly SubmitWorkerPaycardSSNIDVerification =
    submitWorkerPaycardSSNIDVerification(this.Instance);
  public readonly SubmitWorkerPaycardSocialSecurityCardVerification =
    submitWorkerPaycardSocialSecurityCardVerification(this.Instance);
  public readonly GetJurisdictionLaborPosters = getJurisdictionLaborPosters(
    this.Instance
  );
  public readonly DownloadLaborPosterTemplate = downloadLaborPosterTemplate(
    this.Instance
  );
  public readonly GetAccrualPolicyCodes = getAccrualPolicyCodes(this.Instance);
  public readonly PostGenerateEmployeeIDUploadLinkPrivate =
    postGenerateEmployeeIDUploadLinkPrivate(this.Instance);
  public readonly PostGenerateContractorIDUploadLinkPrivate =
    postGenerateContractorIDUploadLinkPrivate(this.Instance);
  public readonly SubmitInvoicePayment = submitInvoicePayment(this.Instance);
  public readonly SendInvoiceEmail = sendInvoiceEmail(this.Instance);
  public readonly SubmitOrderPayment = submitOrderPayment(this.Instance);
  public readonly CreateFinixCard = createFinixCard(this.Instance);
  public readonly GetFinixCards = getFinixCards(this.Instance);
  public readonly GetFinixInfo = getFinixInfo(this.Instance);
  public readonly CreateInvoiceTemplate = createInvoiceTemplate(this.Instance);
  public readonly UpdateInvoiceTemplate = updateInvoiceTemplate(this.Instance);
  public readonly DeleteInvoiceTemplate = deleteInvoiceTemplate(this.Instance);
  public readonly CreateInvoices = createInvoices(this.Instance);
  public readonly CreateInvoicePayout = createInvoicePayout(this.Instance);
  public readonly CreateInstantPayPayout = createInstantPayPayout(
    this.Instance
  );
  public readonly CreateOrderPayout = createOrderPayout(this.Instance);
  public readonly GetInvoiceTemplateById = getInvoiceTemplateById(
    this.Instance
  );
  public readonly GetInvoiceTemplates = getInvoiceTemplates(this.Instance);
  public readonly GetInvoiceLineItems = getInvoiceLineItems(this.Instance);
  public readonly UpdateInvoice = updateInvoice(this.Instance);
  public readonly BulkUpdateInvoiceStatus = bulkUpdateInvoiceStatus(
    this.Instance
  );
  public readonly GetInvoices = getInvoices(this.Instance);
  public readonly GetInvoiceStats = getInvoiceStats(this.Instance);
  public readonly GetInvoiceBulkActionCounts = getInvoiceBulkActionCounts(
    this.Instance
  );
  public readonly GetInvoicePdf = getInvoicePdf(this.Instance);
  public readonly TrackInvoiceView = trackInvoiceView(this.Instance);
  public readonly GetAccrualPolicies = getAccrualPolicies(this.Instance);
  public readonly GetAccrualPolicy = getAccrualPolicy(this.Instance);
  public readonly UpdateWorkerMfaMethod = updateWorkerMfaMethod(this.Instance);
  public readonly GetAccrualBalances = getAccrualBalances(this.Instance);
  public readonly GetEWAPolicies = getEWAPolicies(this.Instance);
  public readonly PatchAccrualBalance = patchAccrualBalance(this.Instance);
  public readonly GetAccrualBalancesByEmployee = getAccrualBalancesByEmployee(
    this.Instance
  );
  public readonly GetAccrualPoliciesActivity = getAccrualPoliciesActivity(
    this.Instance
  );
  public readonly GetAccrualPoliciesWorkers = getAccrualPoliciesWorkers(
    this.Instance
  );
  public readonly GetAccrualPreviews = getAccrualPreviews(this.Instance);
  public readonly UpdateWorkerAstraUser = updateWorkerAstraUser(this.Instance);
  public readonly UpdateAccrualPolicyWorkers = updateAccrualPolicyWorkers(
    this.Instance
  );
  public readonly AcknowledgeHealthInsurance = acknowledgeHealthInsurance(
    this.Instance
  );
  public readonly ValidateAddCardToken = validateAddCardToken(this.Instance);
  public readonly TriggerContractorPayment = triggerContractorPayment(
    this.Instance
  );
  public readonly UpdateCardAutoCharge = updateCardAutoCharge(this.Instance);
  public readonly PostGenerateCustomerAccountShareableLink =
    postGenerateCustomerAccountShareableLink(this.Instance);
  public readonly PostGenerateOrderPaymentLink = postGenerateOrderPaymentLink(
    this.Instance
  );
  public readonly PostGenerateInvoicePaymentLink =
    postGenerateInvoicePaymentLink(this.Instance);
  public readonly ValidateCustomerAccountShareableLinkToken =
    validateCustomerAccountShareableLinkToken(this.Instance);
  public readonly ValidateOrderPaymentShareableLinkToken =
    validateOrderPaymentShareableLinkToken(this.Instance);
  public readonly DeleteFinixCard = deleteFinixCard(this.Instance);
  public readonly UpdateFinixComplianceForm = updateFinixComplianceForm(
    this.Instance
  );
  public readonly GetServiceTypes = getServiceTypes(this.Instance);
  public readonly SavePartnerSignature = savePartnerSignature(this.Instance);
  public readonly GetPartnerInfo = getPartnerInfo(this.Instance);
  public readonly UpdatePartnerInfo = updatePartnerInfo(this.Instance);
  public readonly PostGeneratePartnerAdditionalOwnerLink =
    postGeneratePartnerAdditionalOwnerLink(this.Instance);
  public readonly PostPartnerUBODocument = postPartnerUBODocument(
    this.Instance
  );
  public readonly PostPartnerUBODocumentFromPersona =
    postPartnerUBODocumentFromPersona(this.Instance);
  public readonly GetPartnerUBODocument = getPartnerUBODocument(this.Instance);
  public readonly SignPartnerAgreements = signPartnerAgreements(this.Instance);
  public readonly GetPartnerAgreementPdf = getPartnerAgreementPdf(
    this.Instance
  );
  public readonly CreateCompany = createCompany(this.Instance);
  public readonly UpdateCompanyInfo = updateCompanyInfo(this.Instance);
  public readonly RefreshCompanyOnboardingShareableLinkToken =
    refreshCompanyOnboardingShareableLinkToken(this.Instance);
  public readonly ValidateCompanyOnboardingShareableLinkToken =
    validateCompanyOnboardingShareableLinkToken(this.Instance);
  public readonly PostGenerateCompanyOnboardingShareableLink =
    postGenerateCompanyOnboardingShareableLink(this.Instance);
  public readonly PostCompanyUBODocument = postCompanyUBODocument(
    this.Instance
  );
  public readonly PostCompanyUBODocumentFromPersona =
    postCompanyUBODocumentFromPersona(this.Instance);
  public readonly GetCompanyUBODocument = getCompanyUBODocument(this.Instance);
  public readonly PostCompletePartnerOnboardingFlow =
    postCompletePartnerOnboardingFlow(this.Instance);
  public readonly UpdatePartnerKYCStatus = updatePartnerKYCStatus(
    this.Instance
  );
  public readonly GetCompanyDocumentPdf = getCompanyDocumentPdf(this.Instance);
  public readonly PostCompanyBusinessDocuments = postCompanyBusinessDocuments(
    this.Instance
  );
  public readonly ListCompanyBusinessDocuments = listCompanyBusinessDocuments(
    this.Instance
  );
}
